import { APIData } from './APIData';
export class Persistent {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get runtime() {
        return this.parent;
    }
    handlerCache = new Map();
    entityCache = new Map(); // replace by LRU Cache?
    get edition() {
        // @ts-ignore
        if (typeof window !== 'undefined' && window.edition)
            return window.edition;
        return new Date().getTime();
    }
    route(type, id) {
        return `/api/serialized/${type}/${id}?v=${this.edition}`;
    }
    entityData(type, id) {
        const cacheKey = `${type}_${id}`;
        if (this.handlerCache.has(cacheKey))
            return this.handlerCache.get(cacheKey);
        const handler = new APIData({
            route: this.route(type, id),
            defaultValue: undefined,
        });
        this.handlerCache.set(cacheKey, handler);
        return handler;
    }
    topicData(id) {
        return this.entityData('topic', id);
    }
    pathData(id) {
        return this.entityData('path', id);
    }
    bundleData(id) {
        return this.entityData('bundle', id);
    }
    questionData(id) {
        return this.entityData('question', id);
    }
}
